import React from 'react';
import { observer } from 'mobx-react';
import { computed, observable } from 'mobx';
import styled from '@emotion/styled';
import Text from 'components/text';
import Button from 'components/button/button';
import { Theme } from '@seedlang/constants';
import isBlank from 'is-blank';
import FormWrapper from 'components/authenticate/form_wrapper';
import { flexCenterColumn } from '@seedlang/style_mixins';
import { AppUI } from '@seedlang/state';
import Spinner from 'components/spinner';

const Wrapper = styled.div`
  ${flexCenterColumn()}
  width: 100%;
`;

const Content = styled.div`
  ${flexCenterColumn()}
  width: 100%;
`;

export const OnboardingMemrevCreatePassword = ({
  accentColor,
  disabled,
  onChangePassword,
  onChangePasswordConfirmation,
  onSubmit,
  password,
  passwordConfirmation,
  show,
  showSpinner,
}) => {
  if (showSpinner) {
    return <Spinner background={accentColor || Theme.blue} />;
  }

  return (
    <Wrapper className='onboarding-create-password'>
      <Content>
        <FormWrapper padding={0} color='#000'>
          <Text
            heading='3'
            center
            margin='0 0 20px 0'
            color='#000'
          >
            Set Your Password
          </Text>
          <form onSubmit={onSubmit}>
            <div>
              <label>Password</label>
              <input
                type='password'
                autoFocus={show}
                value={password || ''}
                onChange={e => onChangePassword(e.currentTarget.value)}
                style={{marginBottom: 10}}
              />
            </div>

            <div>
              <label>Password Confirmation</label>
              <input
                type='password'
                value={passwordConfirmation || ''}
                onChange={e => onChangePasswordConfirmation(e.currentTarget.value)}
              />
            </div>

            <Button
              margin='20px 0 0 0'
              height='50px'
              onClick={onSubmit}
              backgroundColor={Theme.green}
              width='100%'
              disabled={disabled}
            >
              Continue
            </Button>
          </form>
        </FormWrapper>
      </Content>
    </Wrapper>
  );
};

@observer
class OnboardingMemrevCreatePasswordWrapper extends React.Component {
  @observable password;
  @observable passwordConfirmation;
  @observable showSpinner = true;

  constructor(props) {
    super(props);
    this.init();
  }

  async init() {
    this.showSpinner = false;
  }

  @computed get disabled() {
    return isBlank(this.password) || this.password !== this.passwordConfirmation || this.password.length < 8;
  }
  onSubmitForm = (e) => {
    e.preventDefault();
    if (!this.disabled) {
      this.onSubmitPassword(this.password);
    }
  }
  onSubmitPassword = (password) => {
    this.showSpinner = true;
    AppUI.authUserStore.update({ data: { password: password, password_confirmation: password } }, this.afterSubmitPassword);
  }
  afterSubmitPassword = () => {
    AppUI.routeToSignedInHome();
  }

  render() {
    return (
      <OnboardingMemrevCreatePassword
        accentColor={AppUI.site.accentColor}
        disabled={this.disabled}
        onChangePassword={password => this.password = password}
        onChangePasswordConfirmation={password => this.passwordConfirmation = password}
        onSubmit={this.onSubmitForm}
        password={this.password}
        passwordConfirmation={this.passwordConfirmation}
        show={this.props.show}
        showSpinner={this.showSpinner}
      />
    );
  }
}

export default OnboardingMemrevCreatePasswordWrapper;
